export const residentialServices = [
    {
      id: 'design-build',
      title: 'Landscape Design & Build',
      image: '/images/landscape/landscapeDesign.jpg',
      description: 'From concept to completion, we create stunning outdoor spaces tailored to your lifestyle.',
      features: [
        'Professional landscape plans',
        'High-end residential installations', 
        'Residential landscape remodels',
        'Complete project management'
      ],
      aspireFeatures: [
        'View 3D designs and project timeline',
        'Track installation progress in real-time',
        'Access detailed project documentation'
      ]
    },
    {
      id: 'hardscape',
      title: 'Hardscape Construction',
      image: '/images/hardscape/hardscapeAS.png',
      description: 'Durable, beautiful hardscape features that add function and value to your property.',
      features: [
        'Pavers & walkways',
        'Retaining walls & natural stone',
        'Fire pits & outdoor living spaces',
        'Water features & pondless systems'
      ],
      aspireFeatures: [
        'Material selections with pricing',
        'Installation scheduling & updates',
        'Warranty tracking & maintenance reminders'
      ]
    },
    {
      id: 'maintenance',
      title: 'Year-Round Maintenance',
      image: '/images/maintenance/mowingBig1.jpg',
      description: 'Keep your landscape looking its best with our comprehensive maintenance programs.',
      features: [
        'Weekly lawn care & mowing',
        'Spring & fall cleanups',
        'Tree & shrub pruning',
        'Irrigation system management',
        'Fertilization & pest management',
        'Holiday lighting installation'
      ],
      aspireFeatures: [
        'Schedule maintenance visits',
        'Receive service completion photos',
        'Track seasonal care calendar',
        'Request additional services instantly'
      ]
    },
    {
      id: 'snow-removal',
      title: 'Snow & Ice Management',
      icon: '❄️',
      description: 'Professional winter services to keep your property safe and accessible.',
      features: [
        'Residential snow plowing',
        'Walkway & driveway clearing',
        'Ice management & salt application',
        'Emergency storm response'
      ],
      aspireFeatures: [
        'Real-time service notifications',
        'Weather alerts & scheduling',
        'Before/after service photos'
      ]
    },
    {
      id: 'fencing',
      title: 'Fencing Solutions',
      icon: '🚧',
      description: 'Quality fencing for security, privacy, and property definition.',
      features: [
        'High tension fixed knot fencing',
        'Top rail & decorative fencing',
        'Corrals & arena construction',
        'Barbed wire & agricultural fencing'
      ],
      aspireFeatures: [
        'Fence line planning & permits',
        'Installation progress tracking',
        'Maintenance scheduling'
      ]
    }
  ];
  
  export const customerBenefits = [
    {
      icon: '📱',
      title: 'Always Connected',
      description: 'Get instant updates, photos, and communicate directly with your crew through our professional system.'
    },
    {
      icon: '📅',
      title: 'Transparent Scheduling',
      description: 'See exactly when we\'ll be at your property with real-time scheduling and weather-based adjustments.'
    },
    {
      icon: '💰',
      title: 'Clear Pricing',
      description: 'No surprises - detailed estimates, transparent billing, and easy payment tracking.'
    },
    {
      icon: '📊',
      title: 'Service History',
      description: 'Complete records of all work performed, warranties, and maintenance recommendations.'
    }
  ];
  
  export const companyInfo = {
    yearsInBusiness: 33,
    location: 'Sun Valley area',
    specialties: [
      'Superior landscape design & installation',
      'Professional landscape plans', 
      'High-end residential remodels',
      'Commercial landscape installations',
      'Year-round maintenance services'
    ],
    philosophy: 'All Seasons excels in producing superior landscapes from initial design to installation. From start to finish and beyond, our exceptional construction and maintenance teams keep new as well as old installations looking new and well kept.'
  };